import React from 'react';

const DataTrustTechScan = () => {
  return (
    <div className="container-fluid p-4">
      <div className="row">
        <div className="col-12">
          <h1 className="mb-4">Data Trust Tech Scan</h1>
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">Technology Trust & Security Scanning</h5>
              <p className="card-text">
                Monitor and assess technology trust scores and security compliance.
              </p>
              <div className="row mt-4">
                <div className="col-md-6">
                  <div className="card bg-light">
                    <div className="card-body">
                      <h6 className="card-title">Trust Score Overview</h6>
                      <div className="row">
                        <div className="col-6">
                          <div className="text-center">
                            <h4 className="text-success">A+</h4>
                            <small>Overall Trust Score</small>
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="text-center">
                            <h4 className="text-info">98.7%</h4>
                            <small>Security Compliance</small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="card bg-light">
                    <div className="card-body">
                      <h6 className="card-title">Scan Statistics</h6>
                      <div className="row">
                        <div className="col-6">
                          <div className="text-center">
                            <h4 className="text-primary">142</h4>
                            <small>Systems Scanned</small>
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="text-center">
                            <h4 className="text-warning">3</h4>
                            <small>Issues Found</small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DataTrustTechScan;